/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountManagerInfo} from '../models/AccountManagerInfo';
import type {AccountPrimaryManager} from '../models/AccountPrimaryManager';
import type {Error} from '../models/Error';
import type {SaveManagerRelationsRequest} from '../models/SaveManagerRelationsRequest';

export interface GetAccountManagerInfo$Request {
    accountId: number;
}

export interface GetAccountManagerInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountManagerInfoRequest = createAction<PayloadData<void, GetAccountManagerInfo$Request>>('ACCOUNT_MANAGER_RELATIONS__GET_ACCOUNT_MANAGER_INFO__REQUEST');
export const getAccountManagerInfoSuccess = createAction<PayloadData<Array<AccountManagerInfo>, GetAccountManagerInfo$Request>>('ACCOUNT_MANAGER_RELATIONS__GET_ACCOUNT_MANAGER_INFO__SUCCESS');
export const getAccountManagerInfoFailure = createAction<PayloadData<Error, GetAccountManagerInfo$Request, true>>('ACCOUNT_MANAGER_RELATIONS__GET_ACCOUNT_MANAGER_INFO__FAILURE');

export const getAccountManagerInfoActions = [
    getAccountManagerInfoRequest,
    getAccountManagerInfoSuccess,
    getAccountManagerInfoFailure
] as const;

/**
 * @param {number} meta.accountId Account ID
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountManagerInfo = (meta: GetAccountManagerInfo$Request, config?: GetAccountManagerInfo$Config) => {
    const TRANSPORT_GET_PARAMS = {
        accountId: meta.accountId,
    };
    return {
        CALL_API: {
            types: getAccountManagerInfoActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/managers`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAccountsManagers$Request {
    requestBody: Array<number>;
}

export interface GetAccountsManagers$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountsManagersRequest = createAction<PayloadData<void, GetAccountsManagers$Request>>('ACCOUNT_MANAGER_RELATIONS__GET_ACCOUNTS_MANAGERS__REQUEST');
export const getAccountsManagersSuccess = createAction<PayloadData<{ [key: string]: AccountPrimaryManager; }, GetAccountsManagers$Request>>('ACCOUNT_MANAGER_RELATIONS__GET_ACCOUNTS_MANAGERS__SUCCESS');
export const getAccountsManagersFailure = createAction<PayloadData<Error, GetAccountsManagers$Request, true>>('ACCOUNT_MANAGER_RELATIONS__GET_ACCOUNTS_MANAGERS__FAILURE');

export const getAccountsManagersActions = [
    getAccountsManagersRequest,
    getAccountsManagersSuccess,
    getAccountsManagersFailure
] as const;

/**
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountsManagers = (meta: GetAccountsManagers$Request, config?: GetAccountsManagers$Config) => {
    return {
        CALL_API: {
            types: getAccountsManagersActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/managers`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveAccountManagerRelations$Request {
    accountId: number;
    saveManagerRelationsRequest?: SaveManagerRelationsRequest;
}

export interface SaveAccountManagerRelations$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveAccountManagerRelationsRequest = createAction<PayloadData<void, SaveAccountManagerRelations$Request>>('ACCOUNT_MANAGER_RELATIONS__SAVE_ACCOUNT_MANAGER_RELATIONS__REQUEST');
export const saveAccountManagerRelationsSuccess = createAction<PayloadData<void, SaveAccountManagerRelations$Request>>('ACCOUNT_MANAGER_RELATIONS__SAVE_ACCOUNT_MANAGER_RELATIONS__SUCCESS');
export const saveAccountManagerRelationsFailure = createAction<PayloadData<Error, SaveAccountManagerRelations$Request, true>>('ACCOUNT_MANAGER_RELATIONS__SAVE_ACCOUNT_MANAGER_RELATIONS__FAILURE');

export const saveAccountManagerRelationsActions = [
    saveAccountManagerRelationsRequest,
    saveAccountManagerRelationsSuccess,
    saveAccountManagerRelationsFailure
] as const;

/**
 * @param {number} meta.accountId Account ID
 * @param {SaveManagerRelationsRequest} [meta.saveManagerRelationsRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveAccountManagerRelations = (meta: SaveAccountManagerRelations$Request, config?: SaveAccountManagerRelations$Config) => {
    const TRANSPORT_GET_PARAMS = {
        accountId: meta.accountId,
    };
    return {
        CALL_API: {
            types: saveAccountManagerRelationsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/managers`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.saveManagerRelationsRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

